import React from 'react';
import Button from '../Button';
import Text from '../Text';
import BackupFooter from './BackupFooter';
import StateHeading from './StateHeading';
import UpgradeIcon, { UpgradeIconName } from './icons/UpgradeIcon';

const benefits: { icon: UpgradeIconName; label: string }[] = [
  { icon: 'group', label: 'Clearer transaction grouping' },
  { icon: 'calculator', label: 'Easier and faster to reconcile' },
  { icon: 'check', label: 'All you need to get the job done' },
];

export default function Introduction({ onContinue, faqUrl }: { onContinue: () => void; faqUrl?: string }) {
  return (
    <>
      <StateHeading title="A major upgrade to your TokenTax account">
        We've rebuilt our data model to give you richer, more accurate transaction data that better reflects
        what happened on-chain.
      </StateHeading>
      <div className="grid grid-cols-1 gap-4 py-6 sm:grid-cols-3">
        {benefits.map(({ icon, label }) => (
          <div key={icon} className="flex flex-col items-center gap-4 rounded-lg p-4 text-center">
            <UpgradeIcon name={icon} boxed />
            <Text as="p" variant="base" className="leading-6">
              {label}
            </Text>
          </div>
        ))}
      </div>
      <div className="space-y-4">
        <Button type="button" variant="primary" fullWidth onClick={onContinue}>
          Continue
        </Button>
        <BackupFooter faqUrl={faqUrl} />
      </div>
    </>
  );
}
